module.exports = __webpack_public_path__ + "media/St 4-Question 13-question.329d783b.wav";